import { render, staticRenderFns } from "./formulaMedicaComponent.vue?vue&type=template&id=24c119fa&scoped=true"
import script from "./formulaMedicaComponent.vue?vue&type=script&lang=js"
export * from "./formulaMedicaComponent.vue?vue&type=script&lang=js"
import style0 from "./formulaMedicaComponent.vue?vue&type=style&index=0&id=24c119fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c119fa",
  null
  
)

export default component.exports